import * as React from "react";
import { Star, Play, ChevronLeft, ChevronRight } from "lucide-react";
import Autoplay from "embla-carousel-autoplay";
import { Link } from "react-router-dom";
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export type Review = {
  name: string;
  product: string;
  brand: string;
  text: string;
  role?: string;
  rating?: number;
  image?: string;
  videoUrl?: string;
  localVideo?: string;
};

export const reviews: Review[] = [
  {
    name: "Heidi LF",
    product: "Seamoss Gel",
    brand: "Flauriel",
    rating: 5,
    text: "I made my first seamoss drink today made from Flauriel seamoss gel. It has the perfect added ingredients in it for inflammation reduction (ginger and turmeric) and the minerals in sea moss are amazing for thyroid health. It is so helpful to have this — I can add it to water, put it in soup to thicken it, or curries. Thank you Flauriel.",
  },
  {
    name: "Simone Dolphin",
    product: "Order & Packaging Experience",
    brand: "Flauriel",
    rating: 5,
    text: "I am so impressed with this company. Ordered my product from Philly, got it in a timely manner. I love doing business with this company and will definitely be a loyal customer. I was very impressed with the packaging.",
  },
  {
    name: "Natasha Leader",
    product: "Guava Cheese",
    brand: "Flauriel",
    text: "Your guava cheese are addictive — watch the taste test!",
    localVideo: "/videos/guava-cheese-review.mp4",
  },
  {
    name: "Ercil",
    product: "Mango Passion Jam",
    brand: "Flauriel",
    rating: 5,
    text: "My favourite too. Definitely would recommend. It's addictive — I eat it straight from the jar most times.",
  },
  {
    name: "Susan",
    product: "CBD Bath and Soaking Salt",
    brand: "Yaphene",
    rating: 5,
    text: "I definitely recommend this product. For about 2 weeks my joints and muscles have been aching and I woke up feeling great.",
  },
  {
    name: "Idris",
    product: "All Products",
    brand: "Yaphene",
    rating: 5,
    text: "I love your products! I believe in them. Since I've found them I've not used any chemical products on my hair. I just love everything.",
  },
  {
    name: "Jean Quinn",
    product: "Balancing Hair Oil",
    brand: "Yaphene",
    rating: 5,
    text: "I don't know what I would do without your hair balancing oil. When we're on island the combination of wind and heat literally cooks my hair and scalp. It end up feeling like cotton candy. I never thought I would have to add oil to my hair. But this is a MUST!",
  },
  {
    name: "Sidamo Jones",
    product: "Vitamin C Serum",
    brand: "Marapa",
    rating: 5,
    text: "This is GOLD IN A BOTTLE. I absolutely love it. My face looks fresh and feels amazing.",
  },
  {
    name: "Xuxa",
    product: "Blemish Oil",
    brand: "Marapa",
    rating: 5,
    text: "I am loving my Blemish Oil! It is working for my skin. I have seen the marks fade and my skin just glowing!",
  },
  {
    name: "Heidi",
    product: "Turmeric Charcoal Soap",
    brand: "Yaphene",
    rating: 5,
    text: "I have no more bumps on my legs and upper arms. My skin is so smooth and soft now.",
  },
  {
    name: "Shinnel",
    product: "Service & Products",
    brand: "Flauriel",
    rating: 5,
    text: "Thanks for your service today. Quick and efficient. I will always recommend my friend.",
  },
  {
    name: "Patonia Williams",
    product: "Potato n Garlic (Lota) Soap",
    brand: "Yaphene",
    rating: 5,
    text: "omg!! in love. I absolutely love this soap. Every time I use it on my face, it leaves it clean and refreshed. I am so glad I came across it at Fro Fes!!",
  },
  {
    name: "Tiffany",
    product: "Nettle Hair Growth Spray",
    brand: "Yaphene",
    rating: 5,
    text: "Yaphene is an amazing brand! I've been using her products for years. The real star for me is her Nettle Hair Growth Spray — my hair grows ridiculously fast when I use it!",
  },
  {
    name: "Michie",
    product: "Onion Hair Tonic & Hemp Honey Hair Lock Butter",
    brand: "Yaphene",
    rating: 5,
    text: "I am in LOVE with the quality of Yaphene's products. These three products together are like the holy grail of healthy hair. Good affordable products — love it love it!",
  },
  {
    name: "Michie",
    product: "Tinted Lip Balm",
    brand: "Yaphene",
    rating: 5,
    text: "I absolutely love it! The naturalness of the ingredients makes the balm very moisturizing — it's the first thing I put on before a run.",
  },
  {
    name: "Customer Review",
    product: "Yaphene Products",
    brand: "Yaphene",
    text: "Watch our customer share their experience with Yaphene products!",
    videoUrl: "https://youtu.be/5enBGChoNyU",
  },
  {
    name: "Customer Review",
    product: "Hot Sauce",
    brand: "Flauriel",
    text: "Watch our customer try one of our Caribbean hot sauces!",
    localVideo: "/videos/hot-sauce-review.mp4",
  },
  {
    name: "Customer Review",
    product: "Sugar Cane Wine",
    brand: "Flauriel",
    text: "Watch our customer's reaction to our Sugar Cane Wine!",
    localVideo: "/videos/sugar-cane-wine-review.mp4",
  },
  {
    name: "Mimi",
    product: "Body Butters",
    brand: "Yaphene",
    text: "Mimi swears by our Body Butters — hear why she can't live without them!",
    localVideo: "/videos/mimi-body-butter-review.mp4",
  },
  {
    name: "Customer Review",
    product: "Nettle Hair Growth Serum",
    brand: "Yaphene",
    text: "Watch our customer share their experience with our Nettle Hair Growth Serum!",
    localVideo: "/videos/nettle-hair-growth-serum-review.mp4",
  },
  {
    name: "Customer Review",
    product: "Vitamin C Serum — Morning Skincare Routine",
    brand: "Marapa",
    text: "Watch our customer's morning skincare routine featuring our Vitamin C Serum!",
    localVideo: "/videos/balm-bond-review-2.mp4",
  },
];

export const VideoFacade = ({ videoUrl, name }: { videoUrl: string; name: string }) => {
  const [loaded, setLoaded] = React.useState(false);
  const videoId = videoUrl.split("/").pop() || "";

  if (loaded) {
    return (
      <div className="aspect-video mb-5 rounded-md overflow-hidden">
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
          title={`${name} video review`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full"
        />
      </div>
    );
  }

  return (
    <button
      onClick={() => setLoaded(true)}
      className="aspect-video mb-5 rounded-md overflow-hidden w-full relative cursor-pointer bg-muted flex items-center justify-center group"
      aria-label={`Play ${name} video review`}
    >
      <img
        src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
        alt={`${name} video review thumbnail`}
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="relative z-10 w-14 h-14 rounded-full bg-primary/80 group-hover:bg-primary flex items-center justify-center transition-colors">
        <Play className="w-6 h-6 text-primary-foreground ml-0.5" />
      </div>
    </button>
  );
};

export const ReviewCard = ({ review }: { review: Review }) => (
  <article className="h-full bg-background/80 backdrop-blur-sm border border-accent/20 rounded-lg p-7 md:p-8 shadow-[0_4px_30px_-12px_hsl(var(--primary)/0.15)] flex flex-col">
    {review.localVideo ? (
      <div className="aspect-video mb-5 rounded-md overflow-hidden">
        <video controls preload="metadata" className="w-full h-full object-cover">
          <source src={review.localVideo} type="video/mp4" />
        </video>
      </div>
    ) : review.videoUrl ? (
      <VideoFacade videoUrl={review.videoUrl} name={review.name} />
    ) : (
      <div className="flex gap-1 mb-4" aria-label={`${review.rating ?? 5} out of 5 stars`}>
        {[...Array(review.rating ?? 5)].map((_, j) => (
          <Star key={j} className="w-4 h-4 fill-accent text-accent" />
        ))}
      </div>
    )}
    <p className="text-[10px] uppercase tracking-[0.25em] text-accent font-sans mb-2">
      {review.brand}
    </p>
    <p className="font-serif text-lg text-foreground mb-4 leading-snug">
      {review.product}
    </p>
    <blockquote className="text-sm md:text-[0.95rem] text-foreground/80 font-sans leading-relaxed mb-6 flex-1">
      <span className="font-serif text-2xl text-accent leading-none mr-1 align-top">“</span>
      {review.text}
      <span className="font-serif text-2xl text-accent leading-none ml-0.5 align-top">”</span>
    </blockquote>
    <footer className="pt-4 border-t border-accent/15">
      <p className="font-serif text-sm font-semibold text-primary">{review.name}</p>
      {review.role && (
        <p className="text-xs text-muted-foreground font-sans mt-0.5">{review.role}</p>
      )}
    </footer>
  </article>
);

const CustomerReviews = () => {
  const autoplayRef = React.useRef(
    Autoplay({ delay: 6000, stopOnInteraction: true, stopOnMouseEnter: true }),
  );
  const [api, setApi] = React.useState<CarouselApi>();
  const [selected, setSelected] = React.useState(0);
  const [snaps, setSnaps] = React.useState<number[]>([]);

  React.useEffect(() => {
    if (!api) return;
    setSnaps(api.scrollSnapList());
    setSelected(api.selectedScrollSnap());
    const onSelect = () => setSelected(api.selectedScrollSnap());
    api.on("select", onSelect);
    api.on("reInit", onSelect);
    return () => {
      api.off("select", onSelect);
    };
  }, [api]);

  return (
    <section
      className="relative py-20 md:py-28 overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, hsl(40 35% 96%) 0%, hsl(40 30% 93%) 100%)",
      }}
      aria-labelledby="reviews-heading"
    >
      {/* Botanical accents */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-16 -left-16 w-64 h-64 rounded-full opacity-20 blur-3xl"
        style={{ background: "radial-gradient(circle, hsl(var(--accent)/0.4), transparent 70%)" }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-20 -right-10 w-72 h-72 rounded-full opacity-20 blur-3xl"
        style={{ background: "radial-gradient(circle, hsl(var(--primary)/0.3), transparent 70%)" }}
      />

      <div className="container mx-auto px-6 relative">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-14">
          <p className="text-[11px] uppercase tracking-[0.3em] text-accent font-sans mb-4">
            Voices from the Island
          </p>
          <h2
            id="reviews-heading"
            className="text-3xl md:text-5xl font-serif text-foreground mb-5"
          >
            What Our Community Says
          </h2>
          <div className="flex items-center justify-center gap-3 text-accent/50" aria-hidden="true">
            <span className="h-px w-10 bg-current" />
            <span className="text-xs">✦</span>
            <span className="h-px w-10 bg-current" />
          </div>
        </div>

        <Carousel
          setApi={setApi}
          opts={{ align: "start", loop: true }}
          plugins={[autoplayRef.current]}
          className="max-w-6xl mx-auto"
        >
          <CarouselContent className="-ml-4 md:-ml-6">
            {reviews.map((review, i) => (
              <CarouselItem
                key={i}
                className="pl-4 md:pl-6 basis-full md:basis-1/2 lg:basis-1/3"
              >
                <ReviewCard review={review} />
              </CarouselItem>
            ))}
          </CarouselContent>

          {/* Controls */}
          <div className="flex items-center justify-center gap-6 mt-10">
            <button
              type="button"
              onClick={() => api?.scrollPrev()}
              aria-label="Previous testimonial"
              className="w-11 h-11 rounded-full border border-accent/40 text-primary bg-background/60 hover:bg-accent hover:text-accent-foreground hover:border-accent transition-colors flex items-center justify-center"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>

            <div className="flex items-center gap-2" role="tablist" aria-label="Testimonial pagination">
              {snaps.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  role="tab"
                  aria-selected={selected === i}
                  aria-label={`Go to testimonial ${i + 1}`}
                  onClick={() => api?.scrollTo(i)}
                  className={cn(
                    "h-1.5 rounded-full transition-all",
                    selected === i
                      ? "w-6 bg-accent"
                      : "w-1.5 bg-accent/30 hover:bg-accent/60",
                  )}
                />
              ))}
            </div>

            <button
              type="button"
              onClick={() => api?.scrollNext()}
              aria-label="Next testimonial"
              className="w-11 h-11 rounded-full border border-accent/40 text-primary bg-background/60 hover:bg-accent hover:text-accent-foreground hover:border-accent transition-colors flex items-center justify-center"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </Carousel>

        <div className="flex justify-center mt-12">
          <Button
            asChild
            variant="outline"
            className="rounded-full border-accent/50 text-primary hover:bg-accent hover:text-accent-foreground hover:border-accent px-8 py-6 font-serif text-base tracking-wide"
          >
            <Link to="/testimonials">Read More Stories</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CustomerReviews;
